export const campaignFilterSelector = (state: any) =>
  state.MarketingReducer.campaignFilter;

export const campaignListSelector = (state: any) =>
  state.MarketingReducer.campaignList;

export const campaignDetailSelector = (state: any) =>
  state.MarketingReducer.campaignDetail;
